var _circle, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCircle2Inline = function SvgCircle2Inline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 36,
    r: 32,
    fill: "url(#circle-2_inline_svg__a)",
    stroke: "#fff",
    strokeWidth: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.457 50.805a.637.637 0 0 1-.914 0C35.112 50.36 25 39.857 25 32.334c-.014-1.493.261-2.973.809-4.355a11.256 11.256 0 0 1 2.382-3.692 10.874 10.874 0 0 1 3.583-2.453A10.613 10.613 0 0 1 36 21a10.613 10.613 0 0 1 4.226.834 10.874 10.874 0 0 1 3.583 2.453 11.256 11.256 0 0 1 2.382 3.692c.548 1.382.823 2.862.808 4.355 0 7.523-10.11 18.027-10.542 18.47ZM36 37a5 5 0 1 0 0-10 5 5 0 0 0 0 10Z",
    fill: "url(#circle-2_inline_svg__b)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "circle-2_inline_svg__a",
    x1: 7.983,
    y1: 7.931,
    x2: 64.007,
    y2: 63.647,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.149,
    stopColor: "#C055F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484,
    stopColor: "#8B55F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.856,
    stopColor: "#3C72DD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "circle-2_inline_svg__b",
    x1: 36.004,
    y1: 14.021,
    x2: 36.004,
    y2: 57.984,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.188,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.832,
    stopColor: "#fff",
    stopOpacity: 0.8
  })))));
};
export default SvgCircle2Inline;